import { render, staticRenderFns } from "./tm-language-select.vue?vue&type=template&id=261c9c28&scoped=true&"
import script from "./tm-language-select.vue?vue&type=script&lang=ts&"
export * from "./tm-language-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261c9c28",
  null
  
)

export default component.exports